import React from 'react';
import { Alert, Typography } from '@mui/material';
import { RecordSection } from './RecordShell';

export interface RecordUsageItem {
  count: number;
  singular: string;
  plural: string;
}

interface RecordUsageProps {
  title: string;
  items: RecordUsageItem[];
  // quando há uso: por que não pode ser excluído e o que fazer
  blockedMessage: string;
  // quando não há uso
  freeMessage: string;
}

// Onde o cadastro é usado; enquanto houver uso, o excluir fica bloqueado.
const RecordUsage: React.FC<RecordUsageProps> = ({ title, items, blockedMessage, freeMessage }) => {
  const used = items.filter(item => item.count > 0);

  return (
    <RecordSection title={title}>
      {used.length === 0 ? (
        <Typography variant="body2" color="textSecondary">
          {freeMessage}
        </Typography>
      ) : (
        <>
          <Typography variant="body2" sx={{ mb: 1 }}>
            {used.map(item => `${item.count} ${item.count === 1 ? item.singular : item.plural}`).join(' · ')}
          </Typography>
          <Alert severity="warning" variant="outlined">
            {blockedMessage}
          </Alert>
        </>
      )}
    </RecordSection>
  );
};

export default RecordUsage;
